<template>
  <div class="fancy-home" v-if="configurations.home_content">

    <div class="hero">
      <div class="container">
        <div class="hero__content">
          <p class="hero__subtitle">{{ $t('fancyHome.heroLearn') }} <span class="scramble"></span>
          </p>
          <h1 class="hero__title" v-if="configurations.home_content.config_value.hero_title">
            {{ configurations.home_content.config_value.hero_title }}
          </h1>
          <p class="hero__description" v-if="configurations.home_content.config_value.hero_description">
            {{ configurations.home_content.config_value.hero_description }}
          </p>
          <div class="hero__buttons-action d-flex gap-3">
            <div v-for="(course, index) in tutorCount" :key="index" class="mb-2">
              <router-link class="button button--green-light d-inline-block"
                :to="{name: 'KidsCoursesList', query: {'course-id': course.course_type}}">
                <span>{{ $t('fancyHome.heroStart') }} {{ course.course_type_name }} {{ $t('fancyHome.heroClass') }}</span>
                <br />
                <span class="subtitle">{{ $t('fancyHome.heroFrom') }} {{ course.tutors_count }} {{
                  $t('fancyHome.heroTeachers') }} </span>
              </router-link>
            </div>
          </div>
        </div>
        <div class="hero__slider-wrapper">
          <template>
            <v-carousel class="hero__slider" height="800" hide-delimiters cycle v-bind:show-arrows="false"
              hide-delimiter-background>
              <v-carousel-item>
                <div class="hero__slider__item"
                  v-bind:style="`background-image: url(${configurations.home_content.config_value.hero_image_1})`">
                </div>
              </v-carousel-item>
              <v-carousel-item>
                <div class="hero__slider__item"
                  v-bind:style="`background-image: url(${configurations.home_content.config_value.hero_image_2})`">
                </div>
              </v-carousel-item>
            </v-carousel>
          </template>
          <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0">
            <defs>
              <clipPath id="heroClip" clipPathUnits="objectBoundingBox">
                <path d="M55 238C213 12 494-53 695 43s243 367 85 593-654 228-654 228-228-399-71-626Z"
                  transform="scale(0.00114, 0.001154)"></path>
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
    </div>

    <!-- Start Why Kuttab-->
    <div class="why-Kuttab">
      <div class="container">
        <h2 class="main-title wow fadeInDown" v-if="configurations.home_content.config_value.why_title">
          {{ configurations.home_content.config_value.why_title }}
        </h2>
        <h3>{{ configurations.home_content.config_value.why_title }}</h3>
        <p>{{ configurations.home_content.config_value.why_description }}</p>
        <div class="row">
          <div class="col-md-3">
            <div class="why-Kuttab--item wow fadeInDown ">
              <div class="p-0 why-kuttab-image-wrapper" data-wow-delay="0.2s">
                <div class="why-kuttab-image"
                  v-bind:style="`background-image: url(${configurations.home_content.config_value.why_image_1})`"></div>
              </div>
              <div class="why-kuttab-content" data-wow-delay="0.2s">
                <div class="icon-box">
                  <svg xmlns="http://www.w3.org/2000/svg" width="64.623" height="63.802" viewBox="0 0 64.623 63.802">
                    <path data-name="Path 5182"
                      d="M300.468,20.393h-1.182a7.874,7.874,0,0,0-6.457-13.828,7.71,7.71,0,0,0-6.307,6.529,7.836,7.836,0,0,0,2.794,7.312h-.261a8.989,8.989,0,0,0-7.776,4.479L279.5,27.973l-4.472-2.71A4.8,4.8,0,0,0,270.1,33.51l8.024,4.9a5.55,5.55,0,0,0,7.071-1.214v7.972a1.632,1.632,0,1,0,3.264,0V32.478a1.632,1.632,0,0,0-2.918-1.005l-2.8,3.584a2.272,2.272,0,0,1-2.938.555l-8.018-4.929a1.538,1.538,0,0,1,1.56-2.651l5.876,3.591h0a1.632,1.632,0,0,0,2.265-.581L284.1,26.51h0a5.714,5.714,0,0,1,4.936-2.853h1.084a3,3,0,0,0,1.632-5.51,4.57,4.57,0,0,1-2.024-4.57A4.493,4.493,0,0,1,293.4,9.783a4.61,4.61,0,0,1,3.408,8.377,3,3,0,0,0,1.645,5.5h2a5.955,5.955,0,0,1,5.948,5.948V42.147a1.5,1.5,0,0,1-3,0V32.354a1.632,1.632,0,0,0-3.264,0v9.793a4.766,4.766,0,0,0,9.532,0V29.6a9.219,9.219,0,0,0-9.2-9.212Z"
                      transform="translate(-245.044 -6.426)" fill="#2f3061"></path>
                    <path data-name="Path 5183"
                      d="M74.436,370.95a1.633,1.633,0,0,0,1.632-1.632V367.5a4.152,4.152,0,0,1,4.146-4.146,3.043,3.043,0,0,0,1.678-5.576,4.179,4.179,0,0,1-1.848-3.453,4.264,4.264,0,0,1,4.055-4.166,4.179,4.179,0,0,1,2.462,7.646,3.042,3.042,0,0,0,1.684,5.569,4.153,4.153,0,0,1,4.146,4.146v1.815a1.632,1.632,0,0,0,3.264,0V367.5a4.152,4.152,0,0,1,4.146-4.146,3.043,3.043,0,0,0,1.678-5.576,4.17,4.17,0,0,1-1.841-3.453,4.264,4.264,0,0,1,4.054-4.166,4.179,4.179,0,0,1,2.462,7.646,3.042,3.042,0,0,0,1.685,5.569,4.153,4.153,0,0,1,4.146,4.146v1.815a1.632,1.632,0,1,0,3.264,0V367.5a4.153,4.153,0,0,1,4.146-4.146,3.043,3.043,0,0,0,1.678-5.576,4.171,4.171,0,0,1-1.848-3.453,4.264,4.264,0,0,1,4.054-4.166,4.179,4.179,0,0,1,2.462,7.646,3.042,3.042,0,0,0,1.685,5.569,4.153,4.153,0,0,1,4.146,4.146v1.815a1.632,1.632,0,1,0,3.264,0V367.5a7.422,7.422,0,0,0-6.764-7.384,7.45,7.45,0,1,0-9.324,0,7.4,7.4,0,0,0-5.138,2.755,7.4,7.4,0,0,0-5.132-2.755,7.443,7.443,0,1,0-9.323,0,7.4,7.4,0,0,0-5.132,2.755,7.4,7.4,0,0,0-5.132-2.755,7.443,7.443,0,1,0-9.323,0A7.422,7.422,0,0,0,72.8,367.5v1.815a1.633,1.633,0,0,0,1.632,1.632Z"
                      transform="translate(-72.803 -307.168)" fill="#2f3061"></path>
                    <path data-name="Path 5184"
                      d="M78.121,9.76h33.3a1.632,1.632,0,1,0,0-3.264h-33.3A5.327,5.327,0,0,0,72.8,11.81V37.489a5.327,5.327,0,0,0,5.321,5.321H101.71a1.632,1.632,0,1,0,0-3.264H78.121a2.056,2.056,0,0,1-2.057-2.057V11.81a2.057,2.057,0,0,1,2.057-2.05Z"
                      transform="translate(-72.8 -6.488)" fill="#2f3061"></path>
                  </svg>
                </div>
                <h3 class="why-Kuttab--title">
                  {{ configurations.home_content.config_value.why_item1title }}
                </h3>
                <p class="why-Kuttab--description">
                  {{ configurations.home_content.config_value.why_item1description }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="why-Kuttab--item wow fadeInDown ">
              <div class="p-0 why-kuttab-image-wrapper" data-wow-delay="0.2s">
                <div class="why-kuttab-image"
                  v-bind:style="`background-image: url(${configurations.home_content.config_value.why_image_2})`"></div>
              </div>
              <div class="why-kuttab-content" data-wow-delay="0.2s">
                <div class="icon-box">
                  <svg xmlns="http://www.w3.org/2000/svg" width="64.623" height="63.802" fill="currentColor"
                    class="bi bi-person-bounding-box" viewBox="0 0 16 16">
                    <path
                      d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5z" />
                    <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                  </svg>
                </div>
                <h3 class="why-Kuttab--title">
                  {{ configurations.home_content.config_value.why_item2title }}
                </h3>
                <p class="why-Kuttab--description">
                  {{ configurations.home_content.config_value.why_item2description }}
                </p>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="why-Kuttab--item wow fadeInDown ">
              <div class="p-0 why-kuttab-image-wrapper" data-wow-delay="0.2s">
                <div class="why-kuttab-image"
                  v-bind:style="`background-image: url(${configurations.home_content.config_value.why_image_3})`"></div>
              </div>
              <div class="why-kuttab-content" data-wow-delay="0.2s">
                <div class="icon-box">
                  <svg xmlns="http://www.w3.org/2000/svg" width="64.623" height="63.802" fill="currentColor"
                    class="bi bi-hourglass-split" viewBox="0 0 16 16">
                    <path
                      d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2h-7zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48V8.35zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z" />
                  </svg>
                </div>
                <h3 class="why-Kuttab--title">
                  {{ configurations.home_content.config_value.why_item3title }}
                </h3>
                <p class="why-Kuttab--description">
                  {{ configurations.home_content.config_value.why_item3description }}
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="why-Kuttab--item wow fadeInDown ">
              <div class="p-0 why-kuttab-image-wrapper" data-wow-delay="0.2s">
                <div class="why-kuttab-image"
                  v-bind:style="`background-image: url(${configurations.home_content.config_value.why_image_4})`"></div>
              </div>
              <div class="why-kuttab-content" data-wow-delay="0.2s">
                <div class="icon-box">
                  <svg xmlns="http://www.w3.org/2000/svg" width="73.776" height="73.554" viewBox="0 0 73.776 73.554">
                    <path data-name="Path 5185"
                      d="M155.45,294.037a10.046,10.046,0,1,0,10.045-10.046A10.056,10.056,0,0,0,155.45,294.037Zm16.761,0a6.716,6.716,0,1,1-6.716-6.716A6.723,6.723,0,0,1,172.211,294.037Z"
                      transform="translate(-147.041 -246.63)" fill="#2f3061"></path>
                    <path data-name="Path 5186"
                      d="M101.334,450.176a10.584,10.584,0,0,1,10.572-10.57h9.107a10.583,10.583,0,0,1,10.57,10.57h3.33a13.916,13.916,0,0,0-13.9-13.9H111.9a13.917,13.917,0,0,0-13.9,13.9Z"
                      transform="translate(-98.004 -376.622)" fill="#2f3061"></path>
                    <path data-name="Path 5187"
                      d="M300.2,69.838l5.481-.683,4.233-.527a21.847,21.847,0,1,0-6.538-7.182l-1.221,3.227Zm22.263-37.749a18.585,18.585,0,1,1-11.632,33.067l-5.564.692,1.8-4.762a18.584,18.584,0,0,1,15.394-29Z"
                      transform="translate(-270.602 -28.76)" fill="#2f3061"></path>
                    <path data-name="Path 5188"
                      d="M418.351,114.226a2.72,2.72,0,0,1,.958.161,2.184,2.184,0,0,1,.732.439,1.876,1.876,0,0,1,.461.666,2.167,2.167,0,0,1,.161.841,2.981,2.981,0,0,1-.146.958,3.13,3.13,0,0,1-.439.834,6.216,6.216,0,0,1-.71.805q-.417.4-.973.87a8.579,8.579,0,0,0-.922.885,4.92,4.92,0,0,0-.658.936,4.281,4.281,0,0,0-.4,1.046,5.351,5.351,0,0,0-.132,1.229,5.456,5.456,0,0,0,.08.9,4.44,4.44,0,0,0,.227.856h3.849a2.077,2.077,0,0,1-.256-.615,2.866,2.866,0,0,1-.095-.717,2.929,2.929,0,0,1,.132-.915,2.8,2.8,0,0,1,.388-.76,5.079,5.079,0,0,1,.643-.724q.388-.366.9-.79.761-.63,1.346-1.221a6.916,6.916,0,0,0,.981-1.236,5.435,5.435,0,0,0,.6-1.368,5.932,5.932,0,0,0,.2-1.617,5.427,5.427,0,0,0-.49-2.407,4.441,4.441,0,0,0-1.361-1.646,5.821,5.821,0,0,0-2.041-.943,10.167,10.167,0,0,0-2.531-.3,11.167,11.167,0,0,0-2.751.337,9.12,9.12,0,0,0-2.458,1.01v4.4a7.781,7.781,0,0,1,2.327-1.441,6.544,6.544,0,0,1,2.37-.475Z"
                      transform="translate(-367.448 -98.442)" fill="#2f3061"></path>
                    <path data-name="Path 5189"
                      d="M432.471,225.45a2.824,2.824,0,0,0-1.946.688,2.191,2.191,0,0,0-.775,1.711,2.3,2.3,0,0,0,.775,1.726,3.05,3.05,0,0,0,3.877.015,2.264,2.264,0,0,0,.746-1.741,2.183,2.183,0,0,0-.761-1.711,2.752,2.752,0,0,0-1.917-.688Z"
                      transform="translate(-381.188 -196.658)" fill="#2f3061"></path>
                  </svg>
                </div>
                <h3 class="why-Kuttab--title">
                  {{ configurations.home_content.config_value.why_item4title }}
                </h3>
                <p class="why-Kuttab--description">
                  {{ configurations.home_content.config_value.why_item4description }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Why Kuttab-->

    <!-- Start Our Courses-->
    <div v-bind:class="`our-courses`" v-for="(courseType, index) in tutorCount" v-bind:key="index">
      <div class="container">
        <h2 class="main-title wow fadeInDown">{{ configurations.home_content.config_value.our_courses }}{{
          courseType.course_type_name }} {{
    $t('fancyHome.courses') }}
        </h2>
        <template>
          <v-sheet class="mx-auto">
            <v-slide-group v-model="coursesCarouselModel" class="pa-4" active-class="success" mobile-breakpoint="776">
              <v-slide-item
                v-for="(course, i) in courses.filter(course => course.course_type_name === courseType.course_type_name)"
                v-bind:key="i" v-slot="{ active, toggle }">
                <div class="course-item ma-4 wow fadeInDown" data-wow-delay="0.2">
                  <a class="course-item--photo" href="#">
                    <img class="img-fluid"
                      v-bind:src="configurations.home_content.config_value[`courses_image_${Math.floor(Math.random() * (3 - 1) + 1)}`]"
                      alt="course photo" />
                  </a>
                  <div class="course-item--body">
                    <router-link class="course-item--name" :title="course.title" :to="{name: 'KidsCoursesList', query: {'course-id': course.course_type_id}}">
                      {{ course.title }}
                    </router-link>
                    <p class="course-item--description">
                      {{ course.description && course.description.length > 80 ? course.description.substring(0, 80) +
                        '...'
                        : course.description }}
                    </p>
                    <div class="course-item--options">
                      <div></div>
                      <router-link class="course-item--see-more" :to="{name: 'KidsCoursesList', query: {'course-id': course.course_type_id}}">
                        {{ configurations.home_content.config_value.needs_6title }}
                        <svg xmlns="http://www.w3.org/2000/svg" class="arrow" width="22.089" height="12.116"
                          viewBox="0 0 22.089 12.116">
                          <path data-name="right-arrow (1)"
                            d="M16.031,107.5l-.984.984,4.378,4.378H0v1.392H19.426l-4.378,4.378,4.378.984.984,6.058-6.058Z"
                            transform="translate(0 -107.5)" fill="#5fae32">
                          </path>
                        </svg>
                      </router-link>
                    </div>
                  </div>
                </div>
              </v-slide-item>
            </v-slide-group>
          </v-sheet>
        </template>
      </div>
    </div>
    <div class="needs">
      <div class="container" v-if="filters.length > 0">
        <h2 class="main-title wow fadeInDown">{{ configurations.home_content.config_value.needs_title }}:
        </h2>
      </div>
      <div class="pricing-container container d-flex  flex-column">
        <div class="row">
          <div class="plan col-md-4" v-if="filters.find(filter => filter.api_param_name === 'genders')">
            <div class="plan-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor"
                class="bi bi-gender-ambiguous" viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                  d="M11.5 1a.5.5 0 0 1 0-1h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-3.45 3.45A4 4 0 0 1 8.5 10.97V13H10a.5.5 0 0 1 0 1H8.5v1.5a.5.5 0 0 1-1 0V14H6a.5.5 0 0 1 0-1h1.5v-2.03a4 4 0 1 1 3.471-6.648L14.293 1H11.5zm-.997 4.346a3 3 0 1 0-5.006 3.309 3 3 0 0 0 5.006-3.31z" />
              </svg>
            </div>
            <div class="title">
              {{ configurations.home_content.config_value.needs_2title }}
            </div>
            <div class="options-container">
              <p class="button button--white mb-2"
                @click="setSelection(option, $event, 'gender')"
                :key="index"
                v-if="(index < 3 || genderShowMore)"
                v-for="(option, index) in filters.find(filter => filter.api_param_name === 'genders').options">
                {{`${option.title} ${configurations.home_content.config_value.tutors}` }}
              </p>
            </div>
            <div class="filter-show-more"
              v-if="(filters.find(filter => filter.api_param_name === 'genders').options.length > 3 && !genderShowMore)"
              v-on:click="(genderShowMore = !genderShowMore)">
              <span>{{ $t('Show more') }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor"
                class="bi bi-arrow-bar-down" viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                  d="M1 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5zM8 6a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 0 1 .708-.708L7.5 12.293V6.5A.5.5 0 0 1 8 6z" />
              </svg>
            </div>
            <div class="filter-show-more"
              v-if="(filters.find(filter => filter.api_param_name === 'genders').options.length > 3 && genderShowMore)"
              v-on:click="(genderShowMore = !genderShowMore)">
              <span>{{ $t('showLess') }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-arrow-bar-up"
                viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                  d="M8 10a.5.5 0 0 0 .5-.5V3.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 3.707V9.5a.5.5 0 0 0 .5.5zm-7 2.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5z" />
              </svg>
            </div>
          </div>
          <div class="plan col-md-4" v-if="filters.find(filter => filter.api_param_name === 'language_ids')">
            <div class="plan-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor" class="bi bi-translate"
                viewBox="0 0 16 16">
                <path
                  d="M4.545 6.714 4.11 8H3l1.862-5h1.284L8 8H6.833l-.435-1.286H4.545zm1.634-.736L5.5 3.956h-.049l-.679 2.022H6.18z" />
                <path
                  d="M0 2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v3h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3H2a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2zm7.138 9.995c.193.301.402.583.63.846-.748.575-1.673 1.001-2.768 1.292.178.217.451.635.555.867 1.125-.359 2.08-.844 2.886-1.494.777.665 1.739 1.165 2.93 1.472.133-.254.414-.673.629-.89-1.125-.253-2.057-.694-2.82-1.284.681-.747 1.222-1.651 1.621-2.757H14V8h-3v1.047h.765c-.318.844-.74 1.546-1.272 2.13a6.066 6.066 0 0 1-.415-.492 1.988 1.988 0 0 1-.94.31z" />
              </svg>
            </div>
            <div class="title">
              {{ configurations.home_content.config_value.needs_3title }}
            </div>
            <div class="options-container">
              <p class="button button--white mb-2"  :key="index"
                @click="setSelection(option, $event, 'language')"
                v-if="(index < 3 || languageShowMore)"
                v-for="(option, index) in filters.find(filter => filter.api_param_name === 'language_ids').options">{{
                  option.title }}
                {{ configurations.home_content.config_value.tutors }}</p>
            </div>
            <div class="filter-show-more"
              v-if="(filters.find(filter => filter.api_param_name === 'language_ids').options.length > 3 && !languageShowMore)"
              v-on:click="(languageShowMore = !languageShowMore)">
              <span>{{ $t('Show more') }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor"
                class="bi bi-arrow-bar-down" viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                  d="M1 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5zM8 6a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 0 1 .708-.708L7.5 12.293V6.5A.5.5 0 0 1 8 6z" />
              </svg>
            </div>
            <div class="filter-show-more"
              v-if="(filters.find(filter => filter.api_param_name === 'language_ids').options.length > 3 && languageShowMore)"
              v-on:click="(languageShowMore = !languageShowMore)">
              <span>{{ $t('showLess') }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-arrow-bar-up"
                viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                  d="M8 10a.5.5 0 0 0 .5-.5V3.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 3.707V9.5a.5.5 0 0 0 .5.5zm-7 2.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5z" />
              </svg>
            </div>
          </div>
          <div class="plan col-md-4" v-if="filters.find(filter => filter.api_param_name === 'country_ids')">
            <div class="plan-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor" class="bi bi-geo-alt"
                viewBox="0 0 16 16">
                <path
                  d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z" />
                <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
              </svg>
            </div>
            <div class="title">
              {{ configurations.home_content.config_value.needs_4title }}
            </div>
            <div class="options-container">
              <p class="button button--white mb-2" :key="index"
              @click="setSelection(option, $event, 'country')"
                v-if="(index < 3 || locationShowMore)"
                v-for="(option, index) in filters.find(filter => filter.api_param_name === 'country_ids').options">{{
                  configurations.home_content.config_value.tutors }} {{ configurations.home_content.config_value.in }} {{
      option.title }}</p>
            </div>
            <div class="filter-show-more"
              v-if="(filters.find(filter => filter.api_param_name === 'country_ids').options.length > 3 && !locationShowMore)"
              v-on:click="(locationShowMore = !locationShowMore)">
              <span>{{ $t('Show more') }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor"
                class="bi bi-arrow-bar-down" viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                  d="M1 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5zM8 6a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 0 1 .708-.708L7.5 12.293V6.5A.5.5 0 0 1 8 6z" />
              </svg>
            </div>
            <div class="filter-show-more"
              v-if="(filters.find(filter => filter.api_param_name === 'country_ids').options.length > 3 && locationShowMore)"
              v-on:click="(locationShowMore = !locationShowMore)">
              <span>{{ $t('showLess') }}</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-arrow-bar-up"
                viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                  d="M8 10a.5.5 0 0 0 .5-.5V3.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 3.707V9.5a.5.5 0 0 0 .5.5zm-7 2.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5z" />
              </svg>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center mt-5">
          <button class="button" @click="filterTutors">{{$t('filterTutor')}}</button>
        </div>
      </div>
    </div>
    <div class="user-guide mb-8">
      <div class="container">
        <h2 class="main-title wow fadeInDown">
          {{ configurations.home_content.config_value.user_guide_title }}
        </h2>
        <div class="wizard my-5">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item flex-fill" role="presentation" data-bs-toggle="tooltip" data-bs-placement="top"
              title="Step 1">
              <a class="nav-link active rounded-circle mx-auto d-flex align-items-center justify-content-center"
                href="#step1" id="step1-tab" data-bs-toggle="tab" role="tab" aria-controls="step1" aria-selected="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
                  <path fill-rule="evenodd"
                    d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z" />
                  <path fill-rule="evenodd"
                    d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z" />
                </svg>
              </a>
            </li>
            <li class="nav-item flex-fill" role="presentation" data-bs-toggle="tooltip" data-bs-placement="top"
              title="Step 2">
              <a class="nav-link rounded-circle mx-auto d-flex align-items-center justify-content-center" href="#step2"
                id="step2-tab" data-bs-toggle="tab" role="tab" aria-controls="step2" aria-selected="false" title="Step 2">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-person-bounding-box" viewBox="0 0 16 16">
                  <path
                    d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5z" />
                  <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                </svg>
              </a>
            </li>
            <li class="nav-item flex-fill" role="presentation" data-bs-toggle="tooltip" data-bs-placement="top"
              title="Step 3">
              <a class="nav-link rounded-circle mx-auto d-flex align-items-center justify-content-center" href="#step3"
                id="step3-tab" data-bs-toggle="tab" role="tab" aria-controls="step3" aria-selected="false" title="Step 3">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-journal-plus" viewBox="0 0 16 16">
                  <path fill-rule="evenodd"
                    d="M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5z" />
                  <path
                    d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z" />
                  <path
                    d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z" />
                </svg>
              </a>
            </li>
            <li class="nav-item flex-fill" role="presentation" data-bs-toggle="tooltip" data-bs-placement="top"
              title="Step 4">
              <a class="nav-link rounded-circle mx-auto d-flex align-items-center justify-content-center" href="#step4"
                id="step4-tab" data-bs-toggle="tab" role="tab" aria-controls="step4" aria-selected="false" title="Step 4">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
                  <path fill-rule="evenodd"
                    d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z" />
                  <path fill-rule="evenodd"
                    d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z" />
                </svg>
              </a>
            </li>
            <li class="nav-item flex-fill" role="presentation" data-bs-toggle="tooltip" data-bs-placement="top"
              title="Step 5">
              <a class="nav-link rounded-circle mx-auto d-flex align-items-center justify-content-center" href="#step5"
                id="step5-tab" data-bs-toggle="tab" role="tab" aria-controls="step5" aria-selected="false" title="Step 5">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-person-bounding-box" viewBox="0 0 16 16">
                  <path
                    d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5z" />
                  <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                </svg>
              </a>
            </li>
            <li class="nav-item flex-fill" role="presentation" data-bs-toggle="tooltip" data-bs-placement="top"
              title="Step 6">
              <a class="nav-link rounded-circle mx-auto d-flex align-items-center justify-content-center" href="#step6"
                id="step6-tab" data-bs-toggle="tab" role="tab" aria-controls="step6" aria-selected="false" title="Step 6">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-journal-plus" viewBox="0 0 16 16">
                  <path fill-rule="evenodd"
                    d="M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5z" />
                  <path
                    d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z" />
                  <path
                    d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z" />
                </svg>
              </a>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" role="tabpanel" id="step1" aria-labelledby="step1-tab">
              <div class="tab-content">
                <div class="row">
                  <div class="col-md-12">
                    <h4 class="step-text">{{ configurations.home_content.config_value.user_guide_subtitle }}</h4>
                    <p>
                      {{ configurations.home_content.config_value.user_guide_description }}
                    </p>
                  </div>
                  <div class="col-md-12">
                    <div class="step-image"
                      v-bind:style="`background-image: url(${configurations.home_content.config_value.user_guide_image_1})`">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade show" role="tabpanel" id="step2" aria-labelledby="step2-tab">
              <div class="tab-content">
                <div class="row">
                  <div class="col-md-12">
                    <h4 class="step-text">{{ configurations.home_content.config_value.user_guide_2title }}</h4>
                    <p>
                      {{ configurations.home_content.config_value.user_guide_explantion }}
                    </p>
                  </div>
                  <div class="col-md-12">
                    <div class="step-image"
                      v-bind:style="`background-image: url(${configurations.home_content.config_value.user_guide_image_2})`">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade show" role="tabpanel" id="step3" aria-labelledby="step3-tab">
              <div class="tab-content">
                <div class="row">
                  <div class="col-md-12">
                    <h4 class="step-text">
                      {{ configurations.home_content.config_value.user_guide_3title }}
                    </h4>
                    <p>
                      {{ configurations.home_content.config_value.user_guide_2explantion }}
                    </p>
                  </div>
                  <div class="col-md-12">
                    <div class="step-image"
                      v-bind:style="`background-image: url(${configurations.home_content.config_value.user_guide_image_3})`">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade show" role="tabpanel" id="step4" aria-labelledby="step4-tab">
              <div class="tab-content">
                <div class="row">
                  <div class="col-md-12">
                    <h4 class="step-text">{{ configurations.home_content.config_value.user_guide_4title }}</h4>
                    <p>{{ configurations.home_content.config_value.user_guide_item_name }}
                    </p>
                  </div>
                  <div class="col-md-12">
                    <div class="step-image"
                      v-bind:style="`background-image: url(${configurations.home_content.config_value.user_guide_image_4})`">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade show" role="tabpanel" id="step5" aria-labelledby="step5-tab">
              <div class="tab-content">
                <div class="row">
                  <div class="col-md-12">
                    <h4 class="step-text">{{ configurations.home_content.config_value.user_guide_2item }}</h4>
                    <p>{{ configurations.home_content.config_value.user_guide_3explantion }}
                    </p>
                  </div>
                  <div class="col-md-12">
                    <div class="step-image"
                      v-bind:style="`background-image: url(${configurations.home_content.config_value.user_guide_image_5})`">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane fade show" role="tabpanel" id="step6" aria-labelledby="step6-tab">
              <div class="tab-content">
                <div class="row">
                  <div class="col-md-12">
                    <h4 class="step-text">{{ configurations.home_content.config_value.user_guide_5title }}</h4>
                    <p>{{ configurations.home_content.config_value.user_guide_4explantion }}
                    </p>
                  </div>
                  <div class="col-md-12">
                    <div class="step-image"
                      v-bind:style="`background-image: url(${configurations.home_content.config_value.user_guide_image_6})`">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Start Become Instructor-->
    <div class="become-instructor"
      v-bind:style="`background-image: url(${configurations.home_content.config_value.become_instructor_image})`">
      <div class="become-instructor--overlay"></div>
      <div class="container">
        <div class="become-instructor--content" data-wow-delay="0.1s" data-wow-duration="1s">
          <h4 class="become-instructor--title"> {{ configurations.home_content.config_value.become_instructor_1title }}
          </h4>
          <p class="become-instructor--description">{{ configurations.home_content.config_value.become_instructor_2title
          }}
          </p><span class="button button--white d-inline-block login-button" @click="openLoginModal">{{
            configurations.home_content.config_value.become_instructor_3title
          }}</span>
        </div>
      </div>
    </div>
    <!-- End Become Instructor-->

    <!-- Start Free trial-->
    <div class="free-trial">
      <div class="container">
        <div class="free-trial--box row">
          <div class="col-md-6 free-trial--photo wow fadeInDown">
            <img class="img-fluid"
              v-bind:src="configurations.home_content.config_value.free_trial_image" alt="free trial photo">
          </div>
          <div class="col-md-6 free-trial--box--content wow fadeInDown" data-wow-delay="0.3s">
            <h4 class="free-trial--title">{{ configurations.home_content.config_value.user_guide_words }}
            </h4>
            <p class="free-trial--description">{{ configurations.home_content.config_value.user_guide_6explantion }}
            </p><a class="button button--green-light d-inline-block login-button" @click="openLoginModal">{{
              configurations.home_content.config_value.user_guide_6title
            }}</a>
          </div>
        </div>
      </div>
    </div>
    <!-- End Free trial-->
    <!-- Start Our Tutors-->
    <div class="our-tutors">
      <div class="container">
        <div class="our-tutors--container">
          <div class="our-tutors__content">
            <h2 class="main-title wow fadeInDown">{{ configurations.home_content.config_value.user_guide_7title }}
            </h2>
            <h3 class="our-tutors__title wow fadeInDown" data-wow-delay="0.1s">{{ tutors.length }}+
              <span>{{ configurations.home_content.config_value.user_guide_3item_name }}</span>
            </h3>
            <p class="our-tutors__description wow fadeInDown" data-wow-delay="0.3s">
              {{ configurations.home_content.config_value.user_guide_4item_name }}
            </p>
          </div>
          <div class="our-tutors__slider-wrapper">
            <template>
              <v-sheet class="mx-auto our-tutors__slider">
                <v-slide-group v-model="tutorsCarousel" class="pa-4 carousel" active-class="success" show-arrows>
                  <v-slide-item v-for="(tutor, index) in tutors" v-bind:key="index">
                    <a class="tutor-card wow fadeInDown mx-2" v-bind:href="`/landing?tutor-id=${tutor.id}`">
                      <div class="tutor-image" v-bind:style="{ backgroundImage: `url(${tutor.profile_picture_url})` }">
                      </div>
                      <h3 class="totur-card__name">{{ tutor.full_name }}</h3>
                      <p class="totur-card__job">{{ tutor && tutor.courses && tutor.courses.join(',') }} {{
                        configurations.home_content.config_value.needs_5title }}</p>
                    </a>
                  </v-slide-item>
                </v-slide-group>
              </v-sheet>
            </template>
            <div class="d-flex justify-content-md-end justify-content-center">
              <router-link class="button button--purple with-icon d-inline-block" :to="{name: 'Tutors'}">{{
                configurations.home_content.config_value.needs_6title }}
                <svg class="arrow" xmlns="http://www.w3.org/2000/svg" width="25.37" height="13.916"
                  viewBox="0 0 25.37 13.916">
                  <path data-name="right-arrow (1)"
                    d="M18.412,107.5l-1.13,1.13,5.029,5.029H0v1.6H22.31l-5.029,5.029,1.13,1.13,6.958-6.958Z"
                    transform="translate(0 -107.5)" fill="#fff"></path>
                </svg></router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Our Tutors-->
    <article class="faq-card container">
      <div class="faq__content">
        <h1 class="faq__title">{{ configurations.home_content.config_value.faq1_subtitle }}</h1>
        <div class="faq__item">
          <h2 class="faq__question">{{ configurations.home_content.config_value.faq2_subtitle }} <img class="arrow-icon"
              src="images/icon-arrow-down.svg" alt="" aria-hidden=“true”></h2>
          <p class="faq__answer">
            {{ configurations.home_content.config_value.faq3_subtitle }}
          </p>
        </div>
        <div class="faq__item">
          <h2 class="faq__question">{{ configurations.home_content.config_value.faq_question }} <img class="arrow-icon"
              src="images/icon-arrow-down.svg" alt="" aria-hidden=“true”></h2>
          <p class="faq__answer">
            {{ configurations.home_content.config_value.faq_answer }}
          </p>
        </div>
        <div class="faq__item">
          <h2 class="faq__question">{{ configurations.home_content.config_value.faq_2question }} <img class="arrow-icon"
              src="images/icon-arrow-down.svg" alt="" aria-hidden=“true”></h2>
          <p class="faq__answer">
            {{ configurations.home_content.config_value.faq2_answer }}
          </p>
        </div>
        <div class="faq__item">
          <h2 class="faq__question">{{ configurations.home_content.config_value.faq3_question }}<img class="arrow-icon"
              src="images/icon-arrow-down.svg" alt="" aria-hidden=“true”></h2>
          <p class="faq__answer">
            {{ configurations.home_content.config_value.faq3_answer }}
          </p>
        </div>
        <div class="faq__item">
          <h2 class="faq__question">{{ configurations.home_content.config_value.faq4_question }} <img class="arrow-icon"
              src="images/icon-arrow-down.svg" alt="" aria-hidden=“true”></h2>
          <p class="faq__answer">
            {{ configurations.home_content.config_value.faq4_answer }}
          </p>
        </div>
        <div class="faq__item">
          <h2 class="faq__question">{{ configurations.home_content.config_value.faq5_question }} <img class="arrow-icon"
              src="images/icon-arrow-down.svg" alt="" aria-hidden=“true”></h2>
          <p class="faq__answer">
            {{ configurations.home_content.config_value.faq5_answer }}
          </p>
        </div>
        <div class="faq__item">
          <h2 class="faq__question">{{ configurations.home_content.config_value.faq6_question }} <img class="arrow-icon"
              src="images/icon-arrow-down.svg" alt="" aria-hidden=“true”></h2>
          <p class="faq__answer">
            {{ configurations.home_content.config_value.faq6_answer }}
          </p>
        </div>
        <div class="faq__item">
          <h2 class="faq__question">{{ configurations.home_content.config_value.faq7_question }} <img class="arrow-icon"
              src="images/icon-arrow-down.svg" alt="" aria-hidden=“true”></h2>
          <p class="faq__answer">
            {{ configurations.home_content.config_value.faq7_answer }}
          </p>
        </div>
      </div>
      <div class="imgs__container">
        <picture>
          <source media="(min-width:900px)"
            srcset="https://kellychi22.github.io/frontend-mentor-solutions/09-faq-accordion-card/images/bg-pattern-desktop.svg">
          <source media="(min-width:0px)"
            srcset="https://kellychi22.github.io/frontend-mentor-solutions/09-faq-accordion-card/images/bg-pattern-mobile.svg">
          <img class="img-bg" src="" alt="" aria-hidden=“true”>
        </picture>
        <picture>
          <source media="(min-width:900px)"
            srcset="https://kellychi22.github.io/frontend-mentor-solutions/09-faq-accordion-card/images/illustration-woman-online-desktop.svg">
          <source media="(min-width:0px)"
            srcset="https://kellychi22.github.io/frontend-mentor-solutions/09-faq-accordion-card/images/illustration-woman-online-mobile.svg">
          <img class="img-woman" src="" alt="" aria-hidden=“true”>
        </picture>
      </div>
      <picture>
        <source media="(min-width:900px)"
          srcset="https://kellychi22.github.io/frontend-mentor-solutions/09-faq-accordion-card/images/illustration-box-desktop.svg">
        <img class="img-box" src="" alt="" aria-hidden=“true”>
      </picture>
    </article>
    <contactForm></contactForm>
  </div>
</template>
  
<script>
import GlobalMixin from "@/GlobalMixin.js";
import contactForm from "@/components/global/contactForm.vue";

export default {
  name: "FancyHome",
  mixins: [GlobalMixin],
  components: {
    contactForm
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      tutorCount: [],
      tutors: [],
      filters: [],
      courses: [],
      locationShowMore: false,
      genderShowMore: false,
      languageShowMore: false,
      textArr: [this.$t('Arabic'), this.$t('Quran'), this.$t('Tajweed')],
      configurations: JSON.parse(localStorage.getItem("configs")),
      tutorsCarousel: false,
      coursesCarouselModel: false,
      interval: null,
      params: []
    };
  },
  mounted() {
    var self = this;
    
    window.addEventListener("localstorageChange", (event) => {
      this.configurations = JSON.parse(event.detail.storage.configs);
    });
    // self.configurations.home_content.config_value = JSON.parse(self.configurations.home_content?.config_value);
    this.axios
      .get(`${process.env.VUE_APP_APIEndPoint}tutor/filters/`, this.headers)
      .then((res) => {
        this.filters = res.data.data.filters;
      })
      .catch((err) => {
        this.displayError(err);
        return console.log(err);
      })
    if (!this.isLoggedIn && !sessionStorage.getItem('landing-contact')) {
      setTimeout(() => {
        let configs = JSON.parse(localStorage.getItem('configs'));
        if (!this.isLoggedIn && !sessionStorage.getItem('landing-contact') && configs.institute_name && configs.institute_name.config_value.includes('kuttab')) {
          $('#contactFormModal').modal({ backdrop: 'static', keyboard: false });
          $('#contactFormModal').modal('show');
        }
      }, 30000);
    }
    this.axios
      .post(`${process.env.VUE_APP_APIEndPoint}tutor/listing/`, {}, this.headers)
      .then((res) => {
        this.tutors = res.data.data.tutors;
        this.axios
          .post(`${process.env.VUE_APP_APIEndPoint}tutor/count/course_type_wise/`, {}, this.headers)
          .then((res) => {
            this.tutorCount = res.data.data.tutor_count;
            self.textArr = this.tutorCount.map(count => count.course_type_name);
            $(document).ready(() => {
              let header = document.querySelector(".header");
              function stickyHeader() {
                if (window.scrollY > 0) {
                  header?.classList?.add('sticky');
                } else {
                  header?.classList?.remove('sticky');
                }
              }
              document.addEventListener('scroll', stickyHeader);
              const test = document.querySelector('.scramble')
              // if(!test) return;
              let currentText = 0;
              const speed = 20 /* The speed/duration of the effect in milliseconds */
              const shuffleCount = 6
              const random = localStorage.getItem("lang") === "en" ? "*&%!1234567ABC" : "أبجدهوزحطيكلمنصعف"
              let LIMIT = self.textArr[currentText].length
              let sliceNo = LIMIT - 1
              let i = 0
              let shuffle = 0
              let mojicount = 0
              this.interval = setInterval(() => triggerScramble(), 2000)
              function scramble() {
                const PROGRESS = test.textContent.length;
                if (PROGRESS < LIMIT) {
                  if (shuffle < shuffleCount) {
                    const mix = Math.floor(Math.random() * (random.length))
                    const output = self.textArr[currentText].slice(0, mojicount)
                    test.innerText = output + random[mix]
                    shuffle++
                    setTimeout(scramble, speed)
                  }
                  else {
                    mojicount++
                    shuffle = 0
                    scramble()
                  }
                }
                else {
                  if (PROGRESS >= LIMIT) {
                    test.innerText = self.textArr[currentText];
                    if (currentText === self.textArr.length - 1) {
                      currentText = 0;
                      LIMIT = self.textArr[currentText].length;
                      sliceNo = LIMIT - 1;
                    } else {
                      currentText++;
                      LIMIT = self.textArr[currentText].length;
                      sliceNo = LIMIT - 1;
                    }
                  }
                }
              }
              /*reset and shuffle*/
              function triggerScramble() {
                shuffle = 0
                mojicount = 0
                if(!test) return;
                test.innerText = ""
                scramble()
              }
              const questions = document.querySelectorAll(".faq__question");
              questions.forEach((question) => {
                question.addEventListener("click", function () {
                  let answer = question.nextElementSibling;
                  if (answer.style.display === "block") {
                    hideAnswer(question);
                  } else {
                    questions.forEach((question) => {
                      hideAnswer(question);
                    });
                    displayAnswer(question);
                  }
                });
              });
              function displayAnswer(target) {
                let answer = target.nextElementSibling;
                let arrowIcon = target.firstElementChild;
                answer.style.display = "block";
                arrowIcon.style.transform = "rotate(180deg)";
                target.style.fontWeight = "700";
              }
              function hideAnswer(target) {
                let answer = target.nextElementSibling;
                let arrowIcon = target.firstElementChild;
                answer.style.display = "none";
                arrowIcon.style.transform = "rotate(0deg)";
                target.style.fontWeight = "700";
              }
              //user-guide
              //Enable Tooltips
              var tooltipTriggerList = [].slice.call(
                document.querySelectorAll('[data-bs-toggle="tooltip"]')
              );
              tooltipTriggerList.map(function (tooltipTriggerEl) {
                return new bootstrap.Tooltip(tooltipTriggerEl);
              });
              //Advance Tabs
              $(".next").click(function () {
                const nextTabLinkEl = $(".nav-tabs .active")
                  .closest("li")
                  .next("li")
                  .find("a")[0];
                const nextTab = new bootstrap.Tab(nextTabLinkEl);
                nextTab.show();
              });
              $(".previous").click(function () {
                const prevTabLinkEl = $(".nav-tabs .active")
                  .closest("li")
                  .prev("li")
                  .find("a")[0];
                const prevTab = new bootstrap.Tab(prevTabLinkEl);
                prevTab.show();
              });
              setInterval(() => {
                let nextTabLinkEl = $(".nav-tabs .active")
                  .closest("li")
                  .next("li")
                  .find("a");
                if (nextTabLinkEl.length > 0) {
                  let nextTab = new bootstrap.Tab(nextTabLinkEl[0]);
                  nextTab.show();
                } else {
                  nextTabLinkEl = $(".nav-tabs li a")[0];
                  if (nextTabLinkEl) {
                    const nextTab = new bootstrap.Tab(nextTabLinkEl);
                    nextTab.show();
                  }
                }

              }, 3000)
            });
            this.tutorCount.forEach((courseType) => {
              this.axios
                .post(`${process.env.VUE_APP_APIEndPoint}tutor/courses/`, {
                  "course_type": courseType.course_type,
                }, this.headers)
                .then((res) => {
                  this.courses = this.courses.concat(res.data.data.courses);
                })
                .catch((err) => {
                  this.displayError(err);
                  return console.log(err);
                })
            })
          })
          .catch((err) => {
            this.displayError(err);
            return console.log(err);
          })
      })
      .catch((err) => {
        this.displayError(err);
        return console.log(err);
      });
  },
  methods: {
    setSelection(option, event, identifier) {
      if(event.target.classList.contains('selected')) {
        const index = this.params.findIndex(o => o.id === identifier && o.value === option.value)
        if(index !== -1) this.params.splice(index, 1)
        event.target.classList.remove('selected')
      }
      else {
        this.params.push({id: identifier, value: option.value})
        event.target.classList.add('selected')
      }
    },
    openLoginModal() {
      window.dispatchEvent(new CustomEvent('loginModalChange', {
        detail: {
          opened: true,
          tab: 0
        }
      }));
    },
    filterTutors() {
      const genders = this.params.filter(p => p.id === 'gender').map(p => p.value).join('_') || undefined
      const language_ids = this.params.filter(p => p.id === 'language').map(p => p.value).join('_') || undefined
      const country_ids = this.params.filter(p => p.id === 'country').map(p => p.value).join('_') || undefined
      this.$router.push({name: 'Tutors', query: {genders, language_ids, country_ids}})
    }
  },
  watch: {
    '$i18n.locale': function (newVal, oldVal) {
      this.headers.headers["accept-language"] = localStorage.lang;
      this.axios
        .get(`${process.env.VUE_APP_APIEndPoint}tutor/filters/`, this.headers)
        .then((res) => {
          this.filters = res.data.data.filters;
          this.configurations = JSON.parse(localStorage.getItem('configs'));
        })
        .catch((err) => {
          this.displayError(err);
          return console.log(err);
          this.configurations = JSON.parse(localStorage.getItem('configs'));
        })
      clearInterval(this.interval);
      this.axios
        .post(`${process.env.VUE_APP_APIEndPoint}tutor/count/course_type_wise/`, {}, this.headers)
        .then((res) => {
          this.tutorCount = res.data.data.tutor_count;
          self.textArr = this.tutorCount.map(count => count.course_type_name);
          this.tutorCount.forEach((courseType) => {
            this.axios
              .post(`${process.env.VUE_APP_APIEndPoint}tutor/courses/`, {
                "course_type": courseType.course_type,
              }, this.headers)
              .then((res) => {
                this.courses = this.courses.concat(res.data.data.courses);
                this.configurations = JSON.parse(localStorage.getItem('configs'));
              })
              .catch((err) => {
                this.displayError(err);
                return console.log(err);
                this.configurations = JSON.parse(localStorage.getItem('configs'));
              })
          })
        })
        .catch((err) => {
          this.displayError(err);
          return console.log(err);
        })
    }
  }
};
</script>
<style lang="scss">
.login-button {
  cursor: pointer;
}
@keyframes float {
  0% {
    transform: translatey(0px);
  }

  50% {
    transform: translatey(-10px);
  }

  100% {
    transform: translatey(0px);
  }
}

@keyframes heroSlider {
  0% {
    transform: scale(1.1) translate(0, 0);
  }

  10% {
    transform: scale(1.1) translate(10px, 10px);
  }

  20% {
    transform: scale(1.1) translate(10px, 0);
  }

  30% {
    transform: scale(1.1) translate(10px, -10px);
  }

  40% {
    transform: scale(1.1) translate(0, -10px);
  }

  50% {
    transform: scale(1.1) translate(-10px, -10px);
  }

  60% {
    transform: scale(1.1) translate(-10px, 0);
  }

  70% {
    transform: scale(1.1) translate(0, 0);
  }

  80% {
    transform: scale(1.1) translate(10px, 10px);
  }

  90% {
    transform: scale(1.1) translate(10px, 0);
  }

  100% {
    transform: scale(1.1) translate(10px, -10px);
  }
}

.hero {
  min-height: 100vh;
  background-color: #42437D;
  padding-top: 170px;
  padding-bottom: 10px;
  position: relative;
  overflow: hidden;
  margin: 0 0 20px 0;
}

@media (max-width: 1679.9px) {
  .hero {
    padding-top: 110px;
  }
}

.hero:before {
  //   content: url("../images/hero-tree.png");
  position: absolute;
  inset-inline-start: 0;
  bottom: -370px;
  opacity: 0.02;
  pointer-events: none;
}

.hero>.container {
  display: flex;
}

@media (max-width: 1199.9px) {
  .hero>.container {
    flex-wrap: wrap;
  }
}

.hero__content {
  padding-top: 0;
  flex: 0 0 calc(100% - 800px);
  padding-inline-end: 0;
}

@media (max-width: 1679.9px) {
  .hero__content {
    flex: 0 0 calc(100% - 600px);
  }
}

@media (max-width: 1399.9px) {
  .hero__content {
    flex: 0 0 calc(100% - 500px);
  }
}

@media (max-width: 1199.9px) {
  .hero__content {
    flex: 0 0 100%;
    padding-inline-end: 0;
    order: 2;
    text-align: center;
    padding-bottom: 3rem;
    text-align: start;
    max-width: 100vw;
  }
}

.hero__subtitle {
  font-size: 2rem;
  color: #fff;
  line-height: 1;
  font-weight: 700;
  margin-bottom: 0;
}

@media (max-width: 1679.9px) {
  .hero__subtitle {
    font-size: 1.5rem;
  }
}

@media (max-width: 575.9px) {
  .hero__subtitle {
    font-size: 1rem;
  }
}

.hero__title {
  font-size: 4.375rem;
  color: #fff;
  font-weight: 700;
  margin-bottom: 20px;
}

@media (max-width: 1679.9px) {
  .hero__title {
    font-size: 3.5rem;
  }
}

@media (max-width: 575.9px) {
  .hero__title {
    font-size: 2rem;
  }
}

.hero__description {
  font-size: 1.25rem;
  line-height: 39px;
  color: #fff;
  font-weight: 500;
  max-width: 640px;
  margin-bottom: 1.5rem;
}

@media (max-width: 1679.9px) {
  .hero__description {
    font-size: 1rem;
    line-height: 30px;
  }
}

@media (max-width: 1199.9px) {
  .hero__description {
    margin: 0 auto 1.5rem;
  }
}

@media (max-width: 575.9px) {
  .hero__description {
    font-size: 0.875rem;
    line-height: 25px;
    max-width: calc(100% - 7px);
  }
}

.hero__buttons-action {
  display: flex;
  align-items: center;
  margin-bottom: 3.75rem;

  div {
    height: 3.5rem;
  }
}

@media (max-width: 1199.9px) {
  .hero__buttons-action {
    justify-content: center;
  }
}

@media (max-width: 767.9px) {
  .hero__buttons-action {
    display: block;
    flex-direction: column;
  }
}

@media (max-width: 1679.9px) {
  .hero__buttons-action .button {
    font-size: 1rem;
    min-height: 60px;
  }
}

@media (min-width: 767.9px) {
  .hero__buttons-action .button {
    margin-bottom: 1rem;
    display: block !important;
    min-height: 60px;
  }
}

.hero__slider-wrapper {
  flex: 0 0 800px;
  width: 800px;
  aspect-ratio: 1.013;
  position: relative;
}

@media (max-width: 1679.9px) {
  .hero__slider-wrapper {
    flex: 0 0 600px;
    width: 600px;
  }
}

@media (max-width: 1399.9px) {
  .hero__slider-wrapper {
    flex: 0 0 500px;
    width: 500px;
  }
}

@media (max-width: 1199.9px) {
  .hero__slider-wrapper {
    margin: 0 auto 1rem;
  }
}

@media (max-width: 575.9px) {
  .hero__slider-wrapper {
    flex: 0 0 300px;
    width: 300px;
    margin-bottom: 0.5rem;
  }
}

.hero__slider-wrapper:before {
  content: "";
  width: 100%;
  height: 100%;
  clip-path: url(#heroClip);
  transform: scale(1.1);
  background: rgba(255, 255, 255, 0.1);
  position: absolute;
  top: 0;
  animation: heroSlider 15s infinite linear alternate;
}

.hero__slider {
  width: 100%;
  height: 100%;
  clip-path: url(#heroClip);
  box-shadow: 15px 15px 0 rgba(255, 255, 255, 0.1);
}

.hero__slider:before {
  content: "";
  width: 100%;
  height: 100%;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='261.864' height='564.282' viewBox='0 0 261.864 564.282'%3E%3Cpath id='Path_5231' data-name='Path 5231' d='M2996.038,2144.068l-.041.024c-12.8-39.966,24.219-112.5,123.385-107.308v130.127a122.588,122.588,0,0,1-51.693,11.34C3032.332,2178.253,3002.157,2163.148,2996.038,2144.068ZM2857.9,1925.353l-.033.016c8.763-52.4,106.5-114.045,222.644.1,11.786,3.307,24.693,7.185,38.873,11.714v22.5c-10.787-5.566-21.929-10.779-33.351-15.54q-7.132,8.71-15.075,16.714c-33.871,33.865-69.792,46.482-102.3,46.484C2903.851,2007.344,2852.569,1957.235,2857.9,1925.353Zm241.76-33.547c-45-2.435-124.762-49.456-157.031-108.349l-.017.017c-35.637-65.052-28.734-137.41,15.437-161.6s108.819,8.971,144.479,74a195.9,195.9,0,0,1,16.856,42.649v137.612q-1.218,3.557-2.57,6.714,1.274,1.453,2.57,2.921v30.106C3113.245,1908.649,3106.585,1900.543,3099.659,1891.805Z' transform='translate(-2857.518 -1613.968)' fill='%23fff'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  background-size: 220px;
  position: absolute;
  top: 0;
  inset-inline-end: 0;
  z-index: 9;
  opacity: 0.13;
}

html[dir=rtl] .hero__slider:before {
  background-position: left 30px;
}

html[dir=ltr] .hero__slider:before {
  background-position: right 30px;
}

.hero__slider .swiper-slide.swiper-slide-active .hero__slider__item {
  transform: scale(1);
}

.hero__slider__item {
  width: 100%;
  height: 100%;
  background: center center no-repeat;
  background-size: cover;
  transform: scale(1.2);
  transition: all 15s ease-in-out;
}

.button {
  padding: 0.75rem 2rem;
  border-radius: 45px;
  font-size: 1rem;
  font-weight: 700;
  transition: all ease-in-out 0.25s;
  border: none;
  white-space: nowrap;
  text-align: center;
}

.button--green {
  background: #5FAE32;
  color: #fff;
}

.button--green-with-icon-box {
  background: rgba(95, 174, 50, 0.12);
  color: #2A2D34;
  padding-inline-start: 1rem;
  padding-inline-end: 2.5rem;
}

.button--green-with-icon-box .icon-box {
  background: #5FAE32;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-inline-end: 1.625rem;
}

@media (max-width: 575.9px) {
  .button--green-with-icon-box .icon-box {
    margin-inline-end: 1rem;
  }
}

.button--green-with-icon-box:hover {
  background: #1A1B39;
  color: #fff;
}

.button--green:hover {
  background: #54942F;
  color: #fff;
}

.button--green-light {
  padding: 0.4rem 0.6rem;
  border-radius: 20px;
  font-size: .9rem;
  transition: all ease-in-out .2s;

  .subtitle {
    font-size: .8rem;
  }
}

.button--white {
  background: #fff;
  color: #2F3061;
}

.button--purple {
  background: #2F3061;
  color: #fff;
  padding: 0.75rem 2.375rem;
}

.button--purple.with-icon svg {
  margin-inline-start: 0.5rem;
}

.button--purple:hover {
  background: #1A1B39;
  color: #fff;
}

.why-Kuttab {
  padding: 0 0 20px 0;
}

.why-Kuttab .row>div:first-child .why-Kuttab--item:hover svg path,
.why-Kuttab .row>div:first-child .why-Kuttab--item:hover svg line {
  stroke: #fff;
  fill: none;
}

.why-Kuttab--item {
  background: rgb(239 247 234);
  border-radius: 30px;
  transition: all ease-in-out 0.25s;
  margin-bottom: 20px !important;
  height: 100%;

  .why-kuttab-content {
    padding: 1rem;
  }

  .why-kuttab-image {
    width: 100%;
    height: 100%;
    background-position: center;
    padding: 0;
    transition: all ease-in-out .3s;
    background-size: cover;
  }

  .why-kuttab-image-wrapper {
    border-radius: 30px 30px 0 0;
    overflow: hidden;
    height: 150px;
  }

  &:nth-child(2n) {
    flex-direction: row-reverse;

    .why-kuttab-image-wrapper {
      border-radius: 30px 0 0 30px;
    }
  }

  &:hover {
    .why-kuttab-image {
      transform: scale(1.5);
    }
  }
}

@media (max-width: 1679.9px) {
  .why-kuttab-content {
    padding: 2.563rem 1rem;
  }
}

@media (max-width: 1399.9px) {
  .why-kuttab-content {
    margin-bottom: 1.25rem;
  }
}

.why-Kuttab--item .icon-box {
  // height: 30px;
  margin-bottom: 1.875rem;
  display: inline-block;

  svg {
    vertical-align: baseline;
  }
}

@media (max-width: 1679.9px) {
  .why-Kuttab--item .icon-box {
    margin-bottom: 1.5rem;
  }

  .why-Kuttab--item .icon-box svg {
    width: 30px;
  }
}

.why-Kuttab--item .icon-box svg path,
.why-Kuttab--item .icon-box svg line {
  transition: all ease-in-out 0.25s;
}

.why-Kuttab--item:hover {
  background: #2F3061;
}

.why-Kuttab--item:hover svg path {
  fill: #fff;
}

.why-Kuttab--item:hover .why-Kuttab--title {
  color: #fff;
}

.why-Kuttab--item:hover .why-Kuttab--description {
  color: #fff;
}

.why-Kuttab--title {
  font-size: 1rem;
  color: #5FAE32;
  font-weight: 700;
  margin: 0 5px;
  transition: all ease-in-out 0.25s;
  display: inline-block;
  width: calc(100% - 65px);
  position: relative;
  top: -15px;
}

.why-Kuttab--description {
  font-size: 1.25rem;
  font-weight: 500;
  color: #343434;
  margin: 0;
  transition: all ease-in-out 0.25s;
}

@media (max-width: 1679.9px) {
  .why-Kuttab--description {
    font-size: 1rem;
  }
}

.needs {
  margin: 0 0 20px 0;
}

.pricing-container {
  margin: auto;

  @media screen and (min-width: 768px) {
    background: rgb(239 247 234);
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
  }

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }

  .plan {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 30px 0px;
    padding: 0px 20px;

    .button {
      max-width: 100%;
      white-space: break-spaces;
    }

    .options-container {
      max-height: 300px;
      padding-top: 20px;
      overflow-y: auto;

      a, p {
        display: block;
        cursor: pointer;

        &.selected {
          background: #EAE509 !important;
        }
      }
    }

    .filter-show-more {
      color: var(--auth-main-color);
      display: flex;
      gap: 2px;
      cursor: pointer;
      font-size: 1.125rem !important;
    }

    &:not(:last-child) {
      border-right: 1px solid rgba(0, 0, 0, 0.1);
    }

    .plan-icon {
      display: flex;
      width: 150px;
      height: 150px;
      justify-content: center;
      align-items: center;
      position: relative;
      font-size: 7rem;
      color: rgba(95, 174, 50, 1);

      &:after {
        content: '';
        width: 100px;
        height: 100px;
        border-radius: 50%;
        background-color: rgba(95, 174, 50, 0.1);
        position: absolute;
      }
    }

    .title {
      text-transform: uppercase;
      color: #444857;
      line-height: 4rem;
      letter-spacing: 2px;
    }

    .features {
      list-style-type: none;
      display: flex;
      flex-direction: column;
      margin: 0;
      padding: 0;

      li {
        line-height: 1.5rem;
        width: 90%;
        padding: 5px;
        display: block;
        text-align: center;
        text-transform: uppercase;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        font-size: 85%;
        color: #5EA9FF;

        &:last-child {
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        }
      }
    }

    .price {
      margin-top: 1rem;
      font-size: 2.5rem;
      line-height: 5rem;
      color: #5EA9FF;
    }

    @media screen and (max-width: 768px) {
      display: flex;
      flex-direction: column;
      background-color: #fff;
      border-radius: 10px;
      box-shadow: 0px 0px 30px 5px rgba(0, 0, 0, 0.3);
      justify-content: space-between;
      padding-bottom: 2rem;
      margin: 10px auto;
    }
  }
}

/** End Breadcrumb General Style **/
/** Start Home Style **/
.main-title {
  color: #5FAE32;
  font-size: 2.625rem;
  padding-top: 0.625rem;
  position: relative;
  margin-bottom: 2.625rem;
}

@media (max-width: 1679.9px) {
  .main-title {
    font-size: 2.125rem;
    margin-bottom: 2.125rem;
  }
}

.main-title::before {
  content: "";
  display: block;
  width: 76px;
  height: 4px;
  background: #5FAE32;
  border-radius: 5px;
  position: absolute;
  top: 0;
  inset-inline-start: 0;
}

@media (max-width: 575.9px) {
  .main-title {
    font-size: 1.625rem;
  }
}


.button--white {
  transition: all ease-in-out .2s;
}


.become-instructor {
  background-attachment: fixed;
  background-size: auto 100%;
  background-repeat: no-repeat;
  position: relative;
  min-height: 780px;
  padding: 100px 0;
  color: #fff;
  display: flex;
  align-items: center;
  z-index: 3;
}

html[dir=rtl] .become-instructor {
  background-position: center right;
}

html[dir=ltr] .become-instructor {
  background-position: center left;
}

@media (max-width: 575.9px) {
  .become-instructor {
    min-height: 550px;
  }
}

.become-instructor:before {
  position: absolute;
  top: 0;
  inset-inline-end: 0;
  opacity: 0.05;
  z-index: 3;
}

@media (max-width: 767.9px) {
  .become-instructor:before {
    display: none;
  }
}

html[dir=rtl] .become-instructor:before {
  transform: rotateY(180deg);
}

.become-instructor:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(47, 48, 97, 0.5);
}

.become-instructor>.container {
  display: flex;
  justify-content: flex-end;
  position: relative;
  z-index: 3;
}

.become-instructor--content {
  max-width: 715px;
}

@media (max-width: 1679.9px) {
  .become-instructor--content {
    max-width: 565px;
  }

  .become-instructor--content .button {
    font-size: 1rem;
  }
}

@media (max-width: 767.9px) {
  .become-instructor--content {
    margin: 0 auto;
    text-align: center;
  }
}

.become-instructor--title {
  font-size: 2.5rem;
  line-height: 1;
  font-weight: 700;
  margin-bottom: 1.2rem;
}

@media (max-width: 1679.9px) {
  .become-instructor--title {
    font-size: 2.125rem;
  }
}

@media (max-width: 575.9px) {
  .become-instructor--title {
    font-size: 1.625rem;
  }
}

.become-instructor--description {
  font-size: 1.875rem;
  margin-bottom: 2rem;
}

@media (max-width: 1679.9px) {
  .become-instructor--description {
    font-size: 1.375rem;
  }
}

@media (max-width: 575.9px) {
  .become-instructor--description {
    font-size: 1.125rem;
  }
}

.become-instructor--overlay {
  position: absolute;
  top: 0;
  inset-inline-end: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
}

html[dir=rtl] .become-instructor--overlay {
  background-image: linear-gradient(to right, #2F3061, #2F3061, rgba(47, 48, 97, 0.76), transparent);
}

html[dir=ltr] .become-instructor--overlay {
  background-image: linear-gradient(to left, #2F3061, #2F3061, rgba(47, 48, 97, 0.76), transparent);
}

.free-trial {
  padding: 55px 0 0 0;
}

.free-trial--box {
  border-radius: 40px;
  background: #EFF7EA;
  padding: 4.125rem 2.75rem;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

@media (max-width: 1199.9px) {
  .free-trial--box {
    padding: 3.125rem 1.75rem;
    justify-content: flex-start;
    align-items: center;
  }
}

@media (max-width: 991.9px) {
  .free-trial--box {
    display: block;
  }
}

@media (max-width: 575.9px) {
  .free-trial--box {
    padding: 1.875rem 1rem;
  }
}

.free-trial--box--content {
  max-width: 725px;
}

@media (max-width: 1679.9px) {
  .free-trial--box--content {
    max-width: 525px;
  }

  .free-trial--box--content .button {
    font-size: 1rem;
  }
}

@media (max-width: 1199.9px) {
  .free-trial--box--content {
    max-width: 400px;
    padding-inline-start: 1.5rem;
  }
}

@media (max-width: 991.9px) {
  .free-trial--box--content {
    max-width: 100%;
    padding-inline-start: 0;
    text-align: center;
  }
}

.free-trial--photo {
  border-radius: 40px;
  overflow: hidden;
}

@media (max-width: 1199.9px) {
  .free-trial--photo {
    position: static;
  }
}

@media (max-width: 991.9px) {
  .free-trial--photo {
    margin-bottom: 2rem;
  }
}

.free-trial--photo img {
  width: 650px;
  aspect-ratio: 1.35;
  object-fit: cover;
  border-radius: 40px;
  overflow: hidden;
}

@media (max-width: 1679.9px) {
  .free-trial--photo img {
    width: 550px;
  }
}

@media (max-width: 1399.9px) {
  .free-trial--photo img {
    width: 450px;
  }
}

@media (max-width: 991.9px) {
  .free-trial--photo img {
    width: 100%;
  }
}

.free-trial--title {
  font-size: 2.75rem;
  line-height: 1;
  color: #2F3061;
  font-weight: 700;
  margin-bottom: 1.875rem;
}

@media (max-width: 1679.9px) {
  .free-trial--title {
    font-size: 2rem;
  }
}

.free-trial--description {
  font-size: 1.5rem;
  color: #343434;
  margin-bottom: 2.75rem;
}

@media (max-width: 1679.9px) {
  .free-trial--description {
    font-size: 1.125rem;
    margin-bottom: 2rem;
  }
}

.our-tutors {
  padding: 70px 0;
  overflow: hidden;
}

.our-tutors--container {
  display: flex;
}

@media (max-width: 991.9px) {
  .our-tutors--container {
    flex-direction: column;
  }
}

.our-tutors__slider-wrapper {
  width: calc(100% - 400px);
  flex: 0 0 calc(100% - 400px);
  padding: 2.75rem 30px;
}

@media (max-width: 1679.9px) {
  .our-tutors__slider-wrapper .button {
    font-size: 1rem;
  }
}

@media (max-width: 1199.9px) {
  .our-tutors__slider-wrapper {
    width: calc(100% - 300px);
    flex: 0 0 calc(100% - 300px);
  }
}

@media (max-width: 991.9px) {
  .our-tutors__slider-wrapper {
    width: 100%;
    flex: unset;
  }
}

.our-tutors__slider {
  width: 100%;
  overflow: visible;
  margin-inline: 0;
  margin-bottom: 2.125rem;
}

.our-tutors__slider .carousel {
  .tutor-card {
    height: 400px;
    width: 300px;
  }

  .tutor-image {
    background-size: cover;
    background-position: center;
    height: 300px;
    width: 100%;
    border-radius: 20px 20px 0 0;
  }
}

@media (max-width: 1679.9px) {
  .our-tutors__slider .swiper-slide {
    width: 245px;
  }
}

.our-tutors__content {
  width: 400px;
  flex: 0 0 400px;
  position: relative;
  z-index: 5;
  padding-inline-end: 60px;
}

@media (max-width: 1199.9px) {
  .our-tutors__content {
    margin-bottom: 2.5rem;
    width: 300px;
    flex: 0 0 300px;
  }
}

@media (max-width: 991.9px) {
  .our-tutors__content {
    width: 100%;
    flex: unset;
    padding-inline-end: 0;
    margin-bottom: 0;
  }
}

.our-tutors__content:before {
  content: "";
  display: block;
  background: #fff;
  width: 20000px;
  height: 100%;
  position: absolute;
  z-index: -1;
  top: 0;
  inset-inline-end: 0;
}

@media (max-width: 991.9px) {
  .our-tutors__content:before {
    content: none;
  }
}

.our-tutors__title {
  font-size: 87px;
  color: #2F3061;
  font-weight: 700;
  margin-bottom: 1.875rem;
}

@media (max-width: 1679.9px) {
  .our-tutors__title {
    font-size: 60px;
    margin-bottom: 1.375rem;
  }
}

.our-tutors__title span {
  display: block;
  font-size: 1.813rem;
}

@media (max-width: 1679.9px) {
  .our-tutors__title span {
    font-size: 1.375rem;
  }
}

@media (max-width: 991.9px) {
  .our-tutors__title {
    display: none;
  }
}

.our-tutors__description {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 500;
  color: #2A2D34;
  line-height: 32px;
}

@media (max-width: 1679.9px) {
  .our-tutors__description {
    font-size: 1rem;
    line-height: 27px;
  }
}

@media (max-width: 991.9px) {
  .our-tutors__description {
    display: none;
  }
}

/** End Button General Style **/
.tutor-card {
  border-radius: 20px;
  color: #2A2D34;
  border: 1px solid #DFDFDF;
  overflow: hidden;
  background-color: #FFF;
  display: block;
  text-decoration: none;
}

.tutor-card img {
  border-radius: 20px;
}

.totur-card__name {
  font-size: 1.25rem;
  color: #2A2D34;
  font-weight: 700;
  margin: 1.125rem 0rem 0rem;
  padding-inline-start: 1rem;
  text-decoration: none;
}

.totur-card__job {
  font-size: 1.1rem;
  color: #2A2D34;
  opacity: 0.6;
  padding-inline-start: 1rem;
  text-decoration: none;
}

.button {
  animation: float 5s ease-in-out infinite;
  text-decoration: none;
  color: white !important;
  background: var(--auth-main-color) !important;

  &:hover {
    background: var(--main-color-hover) !important;
    transform: scale(1.1);
  }
}

.faq-card {
  position: relative;
  margin-top: 8rem;
  margin-bottom: 5rem;
  padding: 2em;
  padding-top: 10em;
  border-radius: 2em;
  color: var(--Very-dark-grayish-blue);
  background-color: rgb(239, 247, 234);
  transition: transform 200ms ease-in;
  margin: 0 auto 20px auto;
  padding-bottom: 0 !important;
  padding-left: 0 !important;
}

.faq-card:hover {
  transform: scale(1.015);
}

.faq__content {
  width: 100%;
  padding: 5em;
}

.faq__title {
  margin-bottom: 1em;
  text-align: center;
  font-size: 2rem;
}

.faq__item {
  width: 100%;
  margin-bottom: 1.5em;
  border-bottom: 1px solid var(--Light-grayish-blue);
}

.faq__question {
  cursor: pointer;
  position: relative;
  margin-bottom: 1em;

  font-size: 1rem;
  color: #5FAE32;
  font-weight: 700;
}

.faq__question:hover {
  color: var(--Soft-red);
}

.faq__answer {
  display: none;
  padding-bottom: 1.5em;
  color: var(--Dark-grayish-blue);
  line-height: 1.5em;
}

.arrow-icon {
  display: inline-block;
  position: absolute;
  top: 35%;
  right: 0;
  transform: rotate(0deg);
  transition: transform 300ms ease;
}

.img-bg {
  position: absolute;
  top: 0;
  left: 140px;
  width: 200px;
}

.img-woman {
  position: absolute;
  top: -85px;
  left: 70px;
  width: 100px;
}

/* attribution styling */

.attribution {
  font-size: 1rem;
  position: absolute;
  top: 0;
  color: var(---Very-dark-blue);
  opacity: 0.75;
}

.attribution a {
  color: white;
  text-decoration: underline;
}

.attribution a:hover {
  color: rgba(255 255 255/0.5);
}

/* media queries */

@media (min-width: 900px) {
  .faq-card {
    display: flex;
    justify-items: center;
    padding: 0;
  }

  .faq__content {
    order: 2;
    width: 80%;
    padding: 5em;
  }

  .faq__title {
    text-align: start;
  }

  .imgs__container {
    width: 20%;
    overflow: hidden;
    position: relative;
    border-radius: 2em 0 0 2em;
  }

  .img-bg {
    position: absolute;
    top: 120px;
    left: 140px;
    transform: scale(400%);
  }

  .img-woman {
    position: absolute;
    top: 170px;
    left: 70px;
    transform: scale(220%);
  }

  .img-box {
    position: absolute;
    top: 190px;
    left: 0;
    transition: transform 1s ease-in;
    width: 100px;
  }

  body:hover .img-box,
  body:focus .img-box {
    animation: up-and-down 1.25s linear infinite alternate;
  }

  @keyframes up-and-down {
    0% {
      transform: translateY(0%);
    }

    100% {
      transform: translateY(-20%);
    }
  }
}

.user-guide {

  .wizard,
  .wizard .nav-tabs,
  .wizard .nav-tabs .nav-item {
    position: relative;
    flex-direction: column;
  }

  .nav-tabs {
    width: 50px;
    display: inline-block;
  }

  .wizard .nav-tabs:after {
    content: "";
    height: 95%;
    width: 1px;
    border-right: solid 2px #ccc;
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left: 50%;
    z-index: -1;
    top: 0;
  }

  .wizard .nav-tabs .nav-item .nav-link {
    width: 50px;
    height: 50px;
    margin-bottom: 50%;
    background: white;
    border: 2px solid #ccc;
    color: #ccc;
    z-index: 10;
  }

  .wizard .nav-tabs .nav-item .nav-link:hover {
    color: #333;
    border: 2px solid #333;
  }

  .wizard .nav-tabs .nav-item .nav-link.active {
    background: #fff;
    border: 2px solid #0dcaf0;
    color: #0dcaf0;
  }

  .nav-tabs .nav-item .nav-link.active:after {
    content: " ";
    position: absolute;
    top: 50%;
    transform: translateY(-50%) rotate(90deg);
    opacity: 1;
    margin: 0 auto;
    left: -0.7rem;
    border: 10px solid transparent;
    border-bottom-color: #0dcaf0;
  }

  .wizard .nav-tabs .nav-item .nav-link svg {
    font-size: 25px;
  }

  .tab-content {
    display: inline-block;
    width: calc(100% - 50px);
    padding-left: 15px;
    top: 0;
    position: absolute;

    .step-image {
      height: 350px;
      background-position: top;
      background-size: contain;
    }
  }

}

.our-courses {
  margin: 0 0 20px 0;
}

.our-courses--slider-container {
  position: relative;
  max-height: 500px;
}

.our-courses--slider-container .swiper-button-next,
.our-courses--slider-container .swiper-button-prev {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #5FAE32;
  border: 1px solid #5FAE32;
  top: -70px;
  transition: all ease-in-out 0.25s;
}

@media (max-width: 575.9px) {

  .our-courses--slider-container .swiper-button-next,
  .our-courses--slider-container .swiper-button-prev {
    position: relative;
    top: 0;
    display: inline-flex;
    margin-bottom: 2rem;
  }
}

@media (max-width: 1679.9px) {

  .our-courses--slider-container .swiper-button-next,
  .our-courses--slider-container .swiper-button-prev {
    width: 45px;
    height: 45px;
  }
}

.our-courses--slider-container .swiper-button-next:hover,
.our-courses--slider-container .swiper-button-prev:hover {
  background: #54942F;
}

.our-courses--slider-container .swiper-button-next {
  inset-inline-start: auto;
}

@media (max-width: 575.9px) {
  .our-courses--slider-container .swiper-button-next {
    inset-inline-start: 80px;
  }
}

.our-courses--slider-container .swiper-button-next.swiper-button-disabled {
  opacity: 1;
  background: transparent;
}

.our-courses--slider-container .swiper-button-next.swiper-button-disabled:after {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29.17' height='11.597' viewBox='0 0 29.17 11.597'%3E%3Cpath id='Path_172' data-name='Path 172' d='M28.9,6.461h0l-4.887,4.863A.935.935,0,0,1,22.688,10L25.97,6.734H.935a.935.935,0,0,1,0-1.871H25.969L22.688,1.6A.935.935,0,0,1,24.008.272L28.9,5.136h0A.936.936,0,0,1,28.9,6.461Z' transform='translate(0 0)' fill='%230180d8'/%3E%3C/svg%3E%0A");
}

.our-courses--slider-container .swiper-button-prev {
  inset-inline-end: 80px;
  inset-inline-start: auto;
}

@media (max-width: 575.9px) {
  .our-courses--slider-container .swiper-button-prev {
    inset-inline-end: auto;
    inset-inline-start: -45px;
  }
}

.our-courses--slider-container .swiper-button-prev.swiper-button-disabled {
  opacity: 1;
  background: transparent;
}

.our-courses--slider-container .swiper-button-prev.swiper-button-disabled:after {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29.17' height='11.597' viewBox='0 0 29.17 11.597'%3E%3Cpath id='Path_172' data-name='Path 172' d='M.274,6.461h0l4.887,4.863A.935.935,0,0,0,6.482,10L3.2,6.734H28.235a.935.935,0,0,0,0-1.871H3.2L6.482,1.6A.935.935,0,0,0,5.162.272L.275,5.136h0A.936.936,0,0,0,.274,6.461Z' transform='translate(0 0)' fill='%230180d8'/%3E%3C/svg%3E%0A");
}

/** Start Course Item General Style **/
.course-item {
  border-radius: 30px;
  position: relative;
  background: #EFF7EA;
  height: 450px;
  width: 260px;

  .course-item--description {
    white-space: pre-wrap;
  }
}

@media (min-width: 500px) {
  .course-item{
    width: 355px;
  }
}

.course-item--photo {
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: 1.625;
  overflow: hidden;
  border-radius: 25px 25px 0 0;
}

.course-item--photo:hover img {
  transform: scale(1.1);
}

.course-item--photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all ease-in-out 0.25s;
  border-radius: 25px 25px 0 0;
}

.course-item--photo:after {
  // content: url("../images/logo-tree.png");
  position: absolute;
  bottom: -5px;
  inset-inline-start: 0;
  opacity: 0.11;
}

.course-item--body {
  padding: 1.5rem 1.875rem;
}

@media (max-width: 1679.9px) {
  .course-item--body {
    padding: 1.375rem 1.625rem;
  }
}

.course-item--name {
  display: inline-block;
  color: #54942F !important;
  font-size: 2rem !important;
  font-weight: 700 !important;
  margin-bottom: 0.875rem;
  transition: all ease-in-out 0.25s;
  text-decoration: none !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
}

@media (max-width: 1679.9px) {
  .course-item--name {
    font-size: 1.5rem;
    margin-bottom: 0.625rem;
  }
}

.course-item--name:hover {
  color: #1A1B39 !important;
}

.course-item--desription {
  color: #2A2D34 !important;
  font-size: 1rem !important;
  line-height: 25px !important;
  font-weight: 500 !important;
  height: 64px;
}

@media (max-width: 1679.9px) {
  .course-item--desription {
    font-size: 1rem;
    line-height: 27px;
    margin-bottom: 1.875rem;
  }
}

.course-item--options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  right: 40px;
  bottom: 15px;
}

.course-item--see-more {
  color: #5FAE32 !important;
  font-size: 1.125rem !important;
  transition: all ease-in-out 0.25s !important;
  text-decoration: none !important;
}

@media (max-width: 1679.9px) {
  .course-item--see-more {
    font-size: 1rem !important;
  }
}

.course-item--see-more svg {
  margin-inline-start: 0.625rem !important;
}

.course-item--see-more svg path {
  transition: all ease-in-out 0.25s !important;
}

.course-item--see-more:hover {
  color: #54942F !important;
}

.course-item--see-more:hover svg path {
  fill: #54942F !important;
}

.course-item--checkbox-container {
  display: block;
}

.course-item--checkbox-container input {
  display: none;
}

.course-item--checkbox-container .button--green {
  display: inline-block;
}

.course-item--checkbox-container .button--green svg {
  display: none;
}

.course-item--checkbox-container input:checked+.button--green {
  background: #2F3061;
  display: block;
  text-align: center;
}

.course-item--checkbox-container input:checked+.button--green>span {
  display: none;
}

.course-item--checkbox-container input:checked+.button--green svg {
  display: inline-block;
}

.course-item.selected:before {
  content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='159.999' height='80.775' viewBox='0 0 159.999 80.775'%3E%3Cpath id='Path_5249' data-name='Path 5249' d='M86.116,37.139C74.24,19.383,47.823,12.89,27.357,10.587v-.411h160V89.513a52.083,52.083,0,0,1-5.961.829c-4.919.412-9.531.61-13.865.61C118.6,90.952,105.21,65.688,86.116,37.139Z' transform='translate(-27.357 -10.176)' fill='%23f5f8f5'/%3E%3Cpath id='noun-check-3496109' d='M111.616,59.9a18.282,18.282,0,1,0-12.927-5.355A18.282,18.282,0,0,0,111.616,59.9Zm-9.49-17.8a1.662,1.662,0,0,1,2.344,0l3.822,3.823,9.623-9.623a1.662,1.662,0,0,1,2.343,2.344l-10.8,10.8h0a1.662,1.662,0,0,1-2.344,0l-4.986-4.986a1.662,1.662,0,0,1,0-2.36Z' transform='translate(3.66 -5.679)' fill='%230180d8'/%3E%3C/svg%3E%0A");
  display: inline-block;
  position: absolute;
  top: -2px;
  inset-inline-end: -2px;
  pointer-events: none;
  z-index: 3;
  border-start-end-radius: 25px;
  overflow: hidden;
}

.swiper-button-next:after {
  content: "";
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29.17' height='11.597' viewBox='0 0 29.17 11.597'%3E%3Cpath id='Path_172' data-name='Path 172' d='M28.9,6.461h0l-4.887,4.863A.935.935,0,0,1,22.688,10L25.97,6.734H.935a.935.935,0,0,1,0-1.871H25.969L22.688,1.6A.935.935,0,0,1,24.008.272L28.9,5.136h0A.936.936,0,0,1,28.9,6.461Z' transform='translate(0 0)' fill='%23fff'/%3E%3C/svg%3E%0A");
  width: 30px;
  aspect-ratio: 2.7;
}

.swiper-button-prev:after {
  content: "";
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29.17' height='11.597' viewBox='0 0 29.17 11.597'%3E%3Cpath id='Path_172' data-name='Path 172' d='M.274,6.461h0l4.887,4.863A.935.935,0,0,0,6.482,10L3.2,6.734H28.235a.935.935,0,0,0,0-1.871H3.2L6.482,1.6A.935.935,0,0,0,5.162.272L.275,5.136h0A.936.936,0,0,0,.274,6.461Z' transform='translate(0 0)' fill='%23fff'/%3E%3C/svg%3E%0A");
  width: 30px;
  aspect-ratio: 2.7;
}

.site-rtl {

  .arrow,
  .v-slide-group__next,
  .v-slide-group__prev {
    transform: rotate(180deg);
  }

  .pricing-container .plan:not(:last-child) {
    border-left: 1px solid rgba(0, 0, 0, 0.1);
    border-right: none;
  }

  .user-guide .nav-tabs {
    margin-left: 15px;
  }

  .become-instructor>.container {
    justify-content: flex-start;
  }
}</style>
  